export default "__VITE_ASSET__9896bdc1__"